module.exports = __webpack_public_path__ + "media/mardigrasvid.eb2d223b.mp4";